import React       from 'react';
import ReactDom    from 'react-dom';

import Const       from 'fw_const';
import Utils       from 'utils';
import Sanitize    from '@utils/sanitize';

// import LazyLoad    from 'react-lazyload';
import Influencer  from '@common/influencer/_influencer';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';

// -------------------------------------------------------


class InfluencerCommon extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal : false,
      tab_mode : null,
    };
  }
  // -------------------------------------------------------
  
  /*
   * モーダルの表示非表示
   */
  toggleModal(flg, tab_mode) {
    this.setState({ modal: flg, tab_mode: tab_mode });
  }
  // -------------------------------------------------------
  
  /*
   * データアップデート
   */
  updateData(column, value) {
    this.props.data[column] = value;
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    if( data.thumbnail == null ) data.thumbnail = '/images/default.jpg';
    
    let base = this.props.base;
    if( base == undefined ) base = {};
    
    let option = this.props.option;
    if( option == undefined ) option = [];
    
    let is_select = false;
    try { is_select = (base.select_influencer[data.insta_user_id] != undefined) } catch(e) {};
    
    let _thumbnail = (
      <div className="thumbnail">
        <img src={data.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
      </div>
    );
    
    // 表示モード
    let view_mode = this.props.view_mode;
    return (
      <div className="influencer-card-common">
        <div className={'influencer-card '+ view_mode} onClick={this.toggleModal.bind(this, true, null)}>
          
          { (option.indexOf('is_popup') >= 0)
            ? <OverlayTrigger placement="top" delayShow={50} overlay={<Tooltip>@{data.insta_id}</Tooltip>}>{_thumbnail}</OverlayTrigger>
            : _thumbnail
          }
          
          { (option.indexOf('is_not_info') == -1) &&
            <div className="influencer-info">
              <h5>@{data.insta_id}</h5>
              <h6 className="follower" data-state="closed"><i className="material-icons">group</i>{Utils.viewInt(data.followers)}</h6>
            </div>
          }
          
          { (is_select == true) && <div className="select-influencer">選択済み</div> }
          { (data.favorite != null) && <i className="material-icons favorite">star</i> }
          
          <MultiSelectAction data={data} base={base} multi_action_flg={this.props.multi_action_flg} />
          
          { (view_mode == 'post_module') && <ShowViewMode data={data} /> }
        </div>
        
        <Influencer view={this.state.modal} tab_mode={this.state.tab_mode} insta_user_id={data.insta_user_id} list={this.props.list} close_ev={this.toggleModal.bind(this)} list_update_ev={this.updateData.bind(this)} base={base} option={option} />
        
        { (this.props.profiling_button === true) && <div className="profiling-button" onClick={this.toggleModal.bind(this, true, 'profiling')}><i className="material-icons">assignment_ind</i>プロファイリング</div> }
      </div>
    );
  }
}
// -------------------------------------------------------

class MultiSelectAction extends React.Component {
  multiOnAction(e) {
    e.stopPropagation();
    
    let base = this.props.base;
    let insta_user_id = this.props.data.insta_user_id;
    
    let multi = base.multi_select;
    if( multi == undefined ) multi = [];
    multi.push(insta_user_id);
    
    base.event.updateData.bind(this)('multi_select', multi);
    
    try {
      let mode = 'register';
      if( base.select_influencer != undefined && base.select_influencer[insta_user_id] != undefined ){
        mode = 'deleted';
      }
      
      base.event.updateData.bind(this)('multi_select_mode', mode);
    } catch(e) {console.log(e)};
  }
  // -------------------------------------------------------
  
  multiOffAction(e) {
    e.stopPropagation();
    
    let base = this.props.base;
    let insta_user_id = this.props.data.insta_user_id;
    
    let multi = base.multi_select;
    multi = multi.filter((id) => { if( id != insta_user_id ) return id; });
    
    base.event.updateData.bind(this)('multi_select', multi);
    
    try { if( multi.length == 0 ) base.event.updateData.bind(this)('multi_select_mode', ''); } catch(e) {};
  }
  // -------------------------------------------------------
  
  render() {
    if( this.props.multi_action_flg !== true ) return null;
    
    let data = this.props.data;
    if( data.thumbnail == null ) data.thumbnail = '/images/default.jpg';
    
    let insta_user_id = data.insta_user_id;
    
    let base = this.props.base;
    if( base == undefined ) base = {};
    
    // 登録済み確認
    try {
      if( base.select_influencer != undefined && base.select_influencer[insta_user_id] != undefined ){
        if( base.multi_select_mode == 'register' ) return null;
        
        let is_first_target = false;
        try { base.workflow.items.candidate.map((d) => { if( d.insta_user_id == insta_user_id ) is_first_target = true; }); } catch(e){}
        try { base.workflow.items.stock.map((d) => { if( d.insta_user_id == insta_user_id ) is_first_target = true; });} catch(e){}
        if( is_first_target == false ) return null;
        
      } else {
        if( base.multi_select_mode == 'deleted' ) return null;
      }
    } catch(e) {}
    
    // 複数選択
    let multi_select = base.multi_select;
    if( multi_select == undefined ) multi_select = [];
    
    if( multi_select.indexOf(insta_user_id) >= 0 ){
      return (
        <div className="multi-select-frame">
          <div className="checkbox-frame" onClick={this.multiOffAction.bind(this)}>
            <input type="checkbox" id={'card_'+ insta_user_id} className="checkbox" defaultChecked disabled={true} />
            <label className="checkbox" htmlFor={'card_'+ insta_user_id} />
          </div>
        </div>
      );
    } else {
      return (
        <div className="multi-not-frame">
          <div className="checkbox-frame" onClick={this.multiOnAction.bind(this)}>
            <input type="checkbox" id={'card_'+ insta_user_id} className="checkbox" defaultChecked disabled={true} />
            <label className="checkbox" htmlFor={'card_'+ insta_user_id} />
          </div>
        </div>
      );
    }
  }
}
// -------------------------------------------------------

class ShowViewMode extends React.Component {
  render() {
    let data = this.props.data;
    
    let posts = [];
    try { if( data.post_json != null ) posts = JSON.parse(data.post_json); } catch(e) {}
    
    return (
      <ul className="post-thumbnails">
        { posts.map((d, key) => {
          if( key >= 9 ) return null;
          if( d.thumbnail == null ) return null;
          
          let caption = null;
          if( d.text != '' ) try { caption = Sanitize.nl2br(d.text); } catch(e) {}
          
          let photo_popup = (
            <div className="photo-popup">
              <div className="thumbnail">
                <img src={d.thumbnail} />
              </div>
              <div className="post-date">
                {Utils.setDate(d.post_date, 'YYYY年M月D日 HH:mm')}
              </div>
              <div className="caption" dangerouslySetInnerHTML={{ __html: caption }} />
            </div>
          );
          
          return (
            <OverlayTrigger key={key} placement="top" delayShow={200} overlay={<Tooltip>{photo_popup}</Tooltip>}>
              <li><img src={d.thumbnail} /></li>
            </OverlayTrigger>
          );
        })}
        
        { (posts.length == 0) && <li className="none">投稿が見つかりません</li> }
      </ul>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InfluencerCommon;